export enum AdminAction {
  All = '*',
  Clone = 'clone',
  Create = 'create',
  Delete = 'delete',
  Edit = 'edit',
  Export = 'export',
  List = 'list',
  Read = 'read',
  Show = 'show',
  Write = 'write',
}

export const ADMIN_ACTION_I18N = {
  [AdminAction.All]: 'Alles',
  [AdminAction.Clone]: 'Klon',
  [AdminAction.Create]: 'Erstellen',
  [AdminAction.Delete]: 'Löschen',
  [AdminAction.Edit]: 'Bearbeiten',
  [AdminAction.Export]: 'Export',
  [AdminAction.List]: 'Listen',
  [AdminAction.Read]: 'Lesen',
  [AdminAction.Show]: 'Anzeigen',
  [AdminAction.Write]: 'Schreiben',
};
